import { LocationDescriptor } from 'history';
import React from 'react';
import { Link } from 'react-router-dom';
import LinkManager from '../../lib/LinkManager';

interface Props {
    to: string | LocationDescriptor | undefined | null,
    children: React.ReactNode,
    onClick?: () => void,
}

export default class UniversalLink extends React.Component<Props> {
    handleOnClick() {
        const { onClick } = this.props;

        if (onClick) {
            onClick();
        }
    }

    render() {
        const { to, children } = this.props;

        if (typeof to === 'string' && LinkManager.isExternalLink(to)) {
            return (<a href={to}>{children}</a>);
        }

        if (!to) {
            return (
                <>
                    {children}
                </>
            );
        }

        return (
            <Link to={to} onClick={() => this.handleOnClick()}>
                {children}
            </Link>
        );
    }
}
